/** EmptyState / ErrorState / LoadingState — content placeholders that respect NVL identity. */
import { Inbox, AlertCircle } from "lucide-react";
import { Button } from "./Button";
import { cn } from "../../lib/cn";

export function EmptyState({ icon: Icon = Inbox, title, description, action, className }) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center px-6 py-16 rounded-[22px] border border-dashed border-line-2 bg-surface",
        className
      )}
      data-testid="empty-state"
    >
      <div className="w-14 h-14 rounded-full bg-surface-2 grid place-items-center mb-5">
        <Icon size={22} className="text-mauve" />
      </div>
      {title && <h3 className="font-display text-[22px] tracking-[-0.01em] mb-2">{title}</h3>}
      {description && <p className="text-text-dim text-[14.5px] max-w-[44ch] mb-6">{description}</p>}
      {action && <div>{action}</div>}
    </div>
  );
}

export function ErrorState({ title = "Something went wrong", description, retry, className }) {
  return (
    <EmptyState
      icon={AlertCircle}
      title={title}
      description={description || "We encountered a temporary issue. Please try again in a few moments."}
      action={retry && <Button onClick={retry}>Try again</Button>}
      className={className}
    />
  );
}

export function LoadingState({ label = "Loading…", className }) {
  return (
    <div className={cn("flex items-center justify-center gap-3 py-16", className)} role="status">
      <span className="w-2 h-2 rounded-full bg-mauve animate-pulse" />
      <span className="w-2 h-2 rounded-full bg-mauve animate-pulse" style={{ animationDelay: "0.2s" }} />
      <span className="w-2 h-2 rounded-full bg-mauve animate-pulse" style={{ animationDelay: "0.4s" }} />
      <span className="sr-only">{label}</span>
    </div>
  );
}
